export default __webpack_public_path__ + "static/media/profileBadge.9db5c4d3.jpg";